import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { PROFILE } from "../data";

const LINKS = [
  { to: "/story", label: "Story" },
  { id: "calatorii", label: "Journeys" },
  { id: "jurnal", label: "Journal" },
  { to: "/shamanic-path", label: "Shamanic Path", isNew: true },
  { id: "filosofie", label: "Philosophy" },
  { to: "/raw-notes", label: "Raw notes" },
  { id: "contact", label: "Connect" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (l) => {
    setOpen(false);
    if (l.to) {
      navigate(l.to);
      return;
    }
    document.getElementById(l.id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#06040A]/80 backdrop-blur-xl border-b border-[#2C223A]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="flex items-center"
        >
          <img
            src="/ovidiu-logo.png"
            alt="Ovidiu"
            className="h-14 sm:h-16 md:h-[72px] w-auto object-contain"
          />
        </button>

        <div className="hidden md:flex items-center gap-10">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-link-${l.id || l.to.replace("/", "")}`}
              onClick={() => go(l)}
              className="relative text-sm tracking-wide text-[#A59DAB] hover:text-[#D6B56D] transition-colors duration-300"
            >
              {l.label}
              {l.isNew && (
                <span
                  data-testid={`nav-new-badge-${l.to?.replace("/", "") || l.id}`}
                  className="absolute -top-3 -right-6 text-[9px] font-bold tracking-widest text-[#06040A] bg-[#D6B56D] px-1.5 py-0.5 rounded-full uppercase"
                >
                  new
                </span>
              )}
            </button>
          ))}
        </div>

        <button
          data-testid="nav-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-[#EBE4D8] text-sm tracking-widest uppercase"
        >
          {open ? "Close" : "Menu"}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#06040A]/95 backdrop-blur-xl border-t border-[#2C223A] px-6 py-6 flex flex-col gap-5">
          {LINKS.map((l) => (
            <button
              key={l.label}
              data-testid={`nav-mobile-link-${l.id || l.to.replace("/", "")}`}
              onClick={() => go(l)}
              className="text-left font-heading text-2xl text-[#EBE4D8] hover:text-[#D6B56D] transition-colors flex items-center gap-3"
            >
              {l.label}
              {l.isNew && (
                <span
                  data-testid={`nav-mobile-new-badge-${l.to?.replace("/", "") || l.id}`}
                  className="text-[10px] font-bold tracking-widest text-[#06040A] bg-[#D6B56D] px-2 py-0.5 rounded-full uppercase"
                >
                  new
                </span>
              )}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};
